// extracted by mini-css-extract-plugin
export default {"stat_ul":"Statistics_stat_ul__OHOs-"};